import {getSchool} from '@/utils/auth.js';
import sotre from '@/store'
var OSS = require('ali-oss');
var client = new OSS({
  region: 'oss-cn-beijing',
  //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
  accessKeyId : "LTAI4FhZiDrH35GgjTAVao3a",
  accessKeySecret : "m1QGtgAxmgyPp66FpMffkQkiuvR3kT",
  // endpoint : "https://fangaoyun.alioss.100eks.cn",
  bucket : "fangaoyun",
});

export async function put(res,flie) {
  let result
  try {
    let names = `${flie}${JSON.parse(getSchool()).project_id}/${sotre.getters.idCard}_${new Date().getTime()}`;
    result = await client.put(names, res);
  } catch (err) {
    console.log(err);
  }
  return result;
}